import { formatConversationText } from '../shared/formatConversationText.js';
import { queryAllAcrossRoots } from './domUtils.js';

/** Format visible text nodes, preserving links, markup, and the SDK message state. */
export function mountConversationTextFormatting(): () => void {
  if (
    typeof document === 'undefined' ||
    typeof window === 'undefined' ||
    typeof MutationObserver === 'undefined' ||
    typeof document.createTreeWalker !== 'function'
  ) {
    return () => {};
  }

  let root: HTMLElement | undefined;
  let frame: number | undefined;
  const selector = '.gengage-chat-bubble-text';
  const options = { childList: true, subtree: true, characterData: true };
  const format = () => {
    frame = undefined;
    if (!root) return;
    observer.disconnect();
    for (const bubble of root.querySelectorAll(selector)) {
      const walker = document.createTreeWalker(bubble, NodeFilter.SHOW_TEXT);
      let node: Node | null;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('code, pre, script, style, textarea, [contenteditable]'))
          continue;
        const original = node.textContent ?? '';
        const formatted = formatConversationText(original);
        if (formatted !== original) node.textContent = formatted;
      }
    }
    observer.observe(root, options);
  };
  const schedule = () => {
    if (frame === undefined) frame = requestAnimationFrame(format);
  };
  const observer = new MutationObserver(schedule);
  const attach = () => {
    const nextRoot = queryAllAcrossRoots('#gengage-chat-scroll')[0];
    if (nextRoot !== root) {
      observer.disconnect();
      root = nextRoot;
      if (root) observer.observe(root, options);
    }
    schedule();
  };
  window.addEventListener('gengage:chat:open', attach);
  attach();
  return () => {
    window.removeEventListener('gengage:chat:open', attach);
    observer.disconnect();
    if (frame !== undefined) cancelAnimationFrame(frame);
  };
}
